export function DEBOUNCE(fn = () => {}, wait = 500) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(null, args);
    }, wait);
  };
}
